import { type ComponentType } from 'react';

import type { PartialBy } from '@kc-console/core';

/**
 * 컴포넌트의 특정 props를 확장하는 HOC, 두번째 인자로 전달된 props를 기본값으로 지정하여 새로운 컴포넌트를 생성합니다.
 *
 * @example
 * const MyComponent = (props: { color: string }) => <span>{props.color}</span>
 * <MyComponent color="red" /> // color(required)
 * const MyExtendedComponent = withPropsExtend(MyComponent, { color: 'red' });
 * <MyExtendedComponent /> // color="red"(optional)
 */
export default function withDefaultProps<
  TProps extends Record<string, any>,
  TExtendedProps extends Partial<TProps> = {},
>(Component: ComponentType<TProps>, extendedProps: TExtendedProps) {
  const ExtendedComponent = (props: PartialBy<TProps, Extract<keyof TExtendedProps, string>>) => {
    const mergedProps = { ...extendedProps, ...props };

    return <Component {...(mergedProps as any)} />;
  };

  return ExtendedComponent;
}
